import { type AssetRelationType } from '@aikoa/common'
import { useGlobalSearchParams, useRouter } from 'expo-router'
import { useCallback } from 'react'
import { AddPropertyFlow } from '~/components/assets/AddPropertyFlow'
import ScreenView from '~/components/layout/ScreenView'

export default function AddPropertyIndex() {
  const router = useRouter()

  const onFlowComplete = useCallback(
    (assetId: string) => {
      router.replace(`/(authenticated)/property/${assetId}`)
    },
    [router]
  )

  const { relationType } = useGlobalSearchParams<{
    relationType?: AssetRelationType
  }>()

  return (
    <ScreenView>
      <AddPropertyFlow onFlowComplete={onFlowComplete} relationType={relationType} />
    </ScreenView>
  )
}
